// extracted by mini-css-extract-plugin
export default {"DivContainer":"WingsCard_DivContainer__fi3fq","InlineDiv":"WingsCard_InlineDiv__U7RNa","Title":"WingsCard_Title__hVAfX"};